module.exports = __webpack_public_path__ + "static/media/pl.80ca74e5.svg";